import { createAction, RSAA } from 'redux-api-middleware'

import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import { DateUtils, ObjectUtils } from '../../utils'
import * as ActionUtils from '../utils'
import * as Fields from './fields'

const Types = {
    API_CALL_FAILURE: 'API_CALL##FAILURE',
    CREATE_DEVICE_REQUEST: 'CREATE_DEVICE##REQUEST',
    CREATE_DEVICE_SUCCESS: 'CREATE_DEVICE##SUCCESS',
    CREATE_DEVICE_FAILURE: 'CREATE_DEVICE##FAILURE',
    DELETE_DEVICE_REQUEST: 'DELETE_DEVICE##REQUEST',
    DELETE_DEVICE_SUCCESS: 'DELETE_DEVICE##SUCCESS',
    DEVICE_UPDATE_REQUEST: 'DEVICE_UPDATE##REQUEST',
    DEVICE_UPDATE_SUCCESS: 'DEVICE_UPDATE##SUCCESS',
    DEVICE_RESTORE_REQUEST: 'DEVICE_RESTORE##REQUEST',
    DEVICE_RESTORE_SUCCESS: 'DEVICE_RESTORE##SUCCESS',
    DEVICE_RESTORE_FAILURE: 'DEVICE_RESTORE##FAILURE',
    FETCH_APK_REQUEST: 'FETCH_APK##REQUEST',
    FETCH_APK_SUCCESS: 'FETCH_APK##SUCCESS',
    FETCH_AUTH_KEYS_REQUEST: 'FETCH_AUTH_KEYS##REQUEST',
    FETCH_AUTH_KEYS_SUCCESS: 'FETCH_AUTH_KEYS##SUCCESS',
    FETCH_DEVICE_GROUPS_REQUEST: 'FETCH_DEVICE_GROUPS##REQUEST',
    FETCH_DEVICE_GROUPS_SUCCESS: 'FETCH_DEVICE_GROUPS##SUCCESS',
    FETCH_DEVICE_SCREENSHOT: 'FETCH_DEVICE_SCREENSHOT',
    FETCH_DEVICE_STATUS_FAILURE: 'FETCH_DEVICE_STATUS##FAILURE',
    FETCH_DEVICE_STATUS_REQUEST: 'FETCH_DEVICE_STATUS##REQUEST',
    FETCH_DEVICE_STATUS_SUCCESS: 'FETCH_DEVICE_STATUS##SUCCESS',
    FETCH_DEVICE_TYPES_REQUEST: 'FETCH_DEVICE_TYPES##REQUEST',
    FETCH_DEVICE_TYPES_SUCCESS: 'FETCH_DEVICE_TYPES##SUCCESS',
    FETCH_DEVICES_FAILURE: 'FETCH_DEVICES##FAILURE',
    FETCH_DEVICES_REQUEST: 'FETCH_DEVICES##REQUEST',
    FETCH_DEVICES_SUCCESS: 'FETCH_DEVICES##SUCCESS',
    FETCH_SINGLE_DEVICE_FAILURE: 'FETCH_SINGLE_DEVICE##FAILURE',
    FETCH_SINGLE_DEVICE_REQUEST: 'FETCH_SINGLE_DEVICE##REQUEST',
    FETCH_SINGLE_DEVICE_SUCCESS: 'FETCH_SINGLE_DEVICE##SUCCESS',
    FETCH_STORE_LOCATIONS_REQUEST: 'FETCH_STORE_LOCATIONS##REQUEST',
    FETCH_STORE_LOCATIONS_SUCCESS: 'FETCH_STORE_LOCATIONS##SUCCESS',
    API_REBOOT_DEVICE: 'DEVICE_API_REBOOT_DEVICE',
    API_REBOOT_DEVICE_SUCCESS: 'DEVICE_API_REBOOT_DEVICE_SUCCESS',
    API_REBOOT_DEVICE_FAILURE: 'DEVICE_API_REBOOT_DEVICE_FAILURE',
    API_CLEAR_DEVICE_CACHE: 'DEVICE_API_CLEAR_DEVICE_CACHE',
    API_CLEAR_DEVICE_CACHE_FAILURE: 'DEVICE_API_CLEAR_DEVICE_CACHE_FAILURE',
    API_CLEAR_DEVICE_CACHE_SUCCESS: 'DEVICE_API_CLEAR_DEVICE_CACHE_SUCCESS',
    API_CLEAR_DEVICE_CONTENT: 'DEVICE_API_CLEAR_DEVICE_CONTENT',
    API_CLEAR_DEVICE_CONTENT_FAILURE: 'DEVICE_API_CLEAR_DEVICE_CONTENT_FAILURE',
    API_CLEAR_DEVICE_CONTENT_SUCCESS: 'DEVICE_API_CLEAR_DEVICE_CONTENT_SUCCESS',
    API_DEMAND_SCREENSHOT: 'DEVICE_API_DEMAND_SCREENSHOT',
    API_DEMAND_SCREENSHOT_SUCCESS: 'DEVICE_API_DEMAND_SCREENSHOT_SUCCESS',
    API_DEMAND_SCREENSHOT_FAILURE: 'DEVICE_API_DEMAND_SCREENSHOT_FAILURE',
    API_UPDATE_CONTENT: 'DEVICE_API_UPDATE_CONTENT',
    API_UPDATE_CONTENT_SUCCESS: 'DEVICE_API_UPDATE_CONTENT_SUCCESS',
    API_UPDATE_CONTENT_FAILURE: 'DEVICE_API_UPDATE_CONTENT_FAILURE',
    API_UPDATE_SETTINGS: 'DEVICE_API_UPDATE_SETTINGS',
    API_UPDATE_SETTINGS_SUCCESS: 'DEVICE_API_UPDATE_SETTINGS_SUCCESS',
    API_UPDATE_SETTINGS_FAILURE: 'DEVICE_API_UPDATE_SETTINGS_FAILURE',
    API_REBOOT: 'DEVICE_API_REBOOT##REQUEST',
    API_REBOOT_SUCCESS: 'DEVICE_API_REBOOT_SUCCESS##SUCCESS',
    API_REBOOT_FAILURE: 'DEVICE_API_REBOOT_FAILURE##FAILURE',
    API_RESTART: 'DEVICE_API_RESTART##REQUEST',
    API_RESTART_SUCCESS: 'DEVICE_API_RESTART_SUCCESS##SUCCESS',
    API_RESTART_FAILURE: 'DEVICE_API_RESTART_FAILURE##FAILURE',
    API_RELOAD_PROMOS: 'DEVICE_API_RELOAD_PROMOS##REQUEST',
    API_RELOAD_PROMOS_SUCCESS: 'DEVICE_API_RELOAD_PROMOS##SUCCESS',
    API_RELOAD_PROMOS_FAILURE: 'DEVICE_API_RELOAD_PROMOS##FAILURE',
    API_OPEN_STATUS_PANEL: 'DEVICE_API_OPEN_STATUS_PANEL##REQUEST',
    API_OPEN_STATUS_PANEL_SUCCESS: 'DEVICE_API_OPEN_STATUS_PANEL##SUCCESS',
    API_OPEN_STATUS_PANEL_FAILURE: 'DEVICE_API_OPEN_STATUS_PANEL##FAILURE',
    CLEAR_DEVICES_LIST: 'CLEAR_DEVICES_LIST',
}

/**
 * @deprecated
 */
export const DeviceActions = Types

/**
 * Update device info
 * @param {Object} device
 * @param {Object} [opts] Options
 * @param {String} [opts.url] Prefix of the url to be called
 */
function deviceUpdate(device, opts) {
    // Check device exists and it is an object
    if (!device || typeof device !== 'object') {
        throw new Error(`Wrong device type. Got: ${typeof device}`)
    }

    const { id: deviceUID } = device

    // Check device exists and it is an object
    if (!deviceUID || typeof deviceUID !== 'string') {
        throw new Error(`Wrong device type. Got: ${typeof deviceUID}`)
    }

    const url = ActionUtils.getUrlFromOpts(opts)
    const body = JSON.stringify(
        ObjectUtils.copy({ ...device, "4k_resolution": device.four_k }, Fields.UpsertDevice, {
            layer_extra: (v) => (typeof v === 'object' ? JSON.stringify(v) : v),
            migrated_at: (v) => (v ? DateUtils.formatDB(v) : undefined),
            store_location: (v) => v && v.toString(),
            cec_enabled: (v) => {
                const value = String(v).trim().toLowerCase()
                if (['true', '1', 'enabled'].includes(value)) return 'enabled'
                if (['false', '0', 'disabled'].includes(value)) return 'disabled'
                return undefined
            },
        })
    )

    return createAction({
        endpoint: `${url}/devices/${deviceUID}`,
        method: 'PUT',
        types: [Types.DEVICE_UPDATE_REQUEST, Types.DEVICE_UPDATE_SUCCESS, Types.API_CALL_FAILURE],
        body,
    })
}

/**
 * Update device info
 * @param UID Device uid
 */
const fetchSingleDevice = (UID) => ({
    [RSAA]: {
        endpoint: `${HUBBLE_API_TOKEN}/devices/${UID}`,
        method: 'GET',
        types: [Types.FETCH_SINGLE_DEVICE_REQUEST, Types.FETCH_SINGLE_DEVICE_SUCCESS, Types.FETCH_SINGLE_DEVICE_FAILURE],
    },
})

/**
 * Fetch devices
 * @param {object} [opts]
 * @param {string} [search] opts
 */
function fetchDevices({ search } = { search: '' }) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices?search=${search}`,
        method: 'GET',
        types: [
            Types.FETCH_DEVICES_REQUEST,
            Types.FETCH_DEVICES_SUCCESS,
            Types.FETCH_DEVICES_FAILURE,
        ],
    })
}

/**
 * Fetch available apk versions
 */
const fetchAvailableApks = () => ({
    [RSAA]: {
        endpoint: `${HUBBLE_API_TOKEN}/apks`,
        method: 'GET',
        types: [Types.FETCH_APK_REQUEST, Types.FETCH_APK_SUCCESS, Types.API_CALL_FAILURE],
    },
})

/**
 * Fetch available apk versions
 */
const fetchAuthKeys = () => ({
    [RSAA]: {
        endpoint: `${HUBBLE_API_TOKEN}/auth_keys`,
        method: 'GET',
        types: [Types.FETCH_AUTH_KEYS_REQUEST, Types.FETCH_AUTH_KEYS_SUCCESS, Types.API_CALL_FAILURE],
    },
})

/**
 * Fetch available device types
 */
const fetchDeviceTypes = () => ({
    [RSAA]: {
        endpoint: `${HUBBLE_API_TOKEN}/device_types`,
        method: 'GET',
        types: [Types.FETCH_DEVICE_TYPES_REQUEST, Types.FETCH_DEVICE_TYPES_SUCCESS, Types.API_CALL_FAILURE],
    },
})

/**
 * Fetch available device display groups
 */
const fetchDeviceGroups = () => ({
    [RSAA]: {
        endpoint: `${HUBBLE_API_TOKEN}/device_groups`,
        method: 'GET',
        types: [Types.FETCH_DEVICE_GROUPS_REQUEST, Types.FETCH_DEVICE_GROUPS_SUCCESS, Types.API_CALL_FAILURE],
    },
})

/**
 * Fetch available apk versions
 */
const fetchStoreLocations = () => ({
    [RSAA]: {
        endpoint: `${HUBBLE_API_TOKEN}/store_locations`,
        method: 'GET',
        types: [Types.FETCH_STORE_LOCATIONS_REQUEST, Types.FETCH_STORE_LOCATIONS_SUCCESS, Types.API_CALL_FAILURE],
    },
})

/**
 * Creates a new device
 * @param {Object} device
 * @param {Object} [opts] Options
 * @param {String} [opts.url] Prefix of the url to be called
 */
function createDevice(device, opts = {}) {
    const body = JSON.stringify(
        ObjectUtils.copy({...device, "4k_resolution": device.four_k}, Fields.UpsertDevice, {
            migrated_at: (v) => DateUtils.formatDB(v),
            store_location: (v) => v && v.toString(),
        })
    )
    const url = ActionUtils.getUrlFromOpts(opts)

    return createAction({
        endpoint: `${url}/devices`,
        method: 'POST',
        types: [Types.CREATE_DEVICE_REQUEST, Types.CREATE_DEVICE_SUCCESS, Types.CREATE_DEVICE_FAILURE],
        body,
    })
}

/**
 * Delete a device
 * @param {String} uid
 * @param {Object} [opts] Options
 * @param {String} [opts.url] Prefix of the url to be called
 * @param {String} [opts.reason] Prefix of the url to be called
 */
function deleteDevice(uid, opts = {}) {
    const url = ActionUtils.getUrlFromOpts(opts)
    const { reason } = opts

    return createAction({
        endpoint: `${url}/devices/${uid}`,
        body: JSON.stringify({ reason }),
        method: 'DELETE',
        types: [Types.DELETE_DEVICE_REQUEST, Types.DELETE_DEVICE_SUCCESS, Types.API_CALL_FAILURE],
    })
}

/**
 * Restores a deleted device
 * @param {String} uid Device ID
 * @param {Object} [opts] Options
 * @param {String} [opts.url] Prefix of the url to be called
 */
function restoreDevice(uid, opts = {}) {
    const url = ActionUtils.getUrlFromOpts(opts)

    return createAction({
        endpoint: `${url}/restore/device/${uid}`,
        method: 'PUT',
        types: [Types.DEVICE_RESTORE_REQUEST, Types.DEVICE_RESTORE_SUCCESS, Types.DEVICE_RESTORE_FAILURE],
    })
}

/**
 * Creates a device. If the creation fails, it tries restoring and updating the device
 * just in case the device was already created but deleted
 * @param {Object} device
 * @param {Object} [opts] Options
 * @param {String} [opts.url] Prefix of the url to be called
 */
function createOrRestoreDevice(device, opts = {}) {
    // Check device exists and it is an object
    if (!device || typeof device !== 'object') {
        throw new Error(`Wrong device type. Got: ${typeof device}`)
    }

    const { id } = device

    return async (dispatch) => {
        // Tries to create a new device in the purgatory
        let action = await dispatch(createDevice(device, opts))
        const { type: creationType } = action

        // Check if device was created
        if (creationType === Types.CREATE_DEVICE_SUCCESS) {
            return [true, action]
        }

        // At this point, previous call failed,
        // and it may mean that it was previously created but deleted

        action = await dispatch(restoreDevice(id, opts))
        const { type: restoreType } = action

        // Check if device failed restoring
        if (restoreType !== Types.DEVICE_RESTORE_SUCCESS) {
            return [false, action]
        }

        // Update the restored device
        action = await dispatch(deviceUpdate(device, opts))
        const { type: updateType } = action

        return [updateType === Types.DEVICE_UPDATE_SUCCESS, action]
    }
}

const fetchScreenshot = (uid) => ({
    type: Types.FETCH_DEVICE_SCREENSHOT,
    payload: { uid },
})

/**
 * Fetch device status
 * @param {String} device Device ID
 */
function fetchDeviceStatus(device) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/${device}/status`,
        method: 'GET',
        types: [Types.FETCH_DEVICE_STATUS_REQUEST, Types.FETCH_DEVICE_STATUS_SUCCESS, Types.FETCH_DEVICE_STATUS_FAILURE],
    })
}

/**
 * Updates the layer extra object from a device
 * @param {Object} layerExtra
 * @param {String} deviceId
 */
function updateLayerExtra(layerExtra, deviceId) {
    if (typeof layerExtra !== 'object') {
        throw new Error('`layerExtra` is not an object')
    }

    if (!deviceId) {
        throw new Error('`deviceId` is not defined')
    }

    return async (dispatch) => {
        const action = await dispatch(deviceUpdate({ layer_extra: layerExtra }, deviceId))
        const { type } = action
        return [type === Types.DEVICE_UPDATE_SUCCESS, action]
    }
}

/**
 * demand screenshot device
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function demandScreenshotViaApi(deviceId) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/${deviceId}/update_screenshot`,
        method: 'POST',
        types: [Types.API_DEMAND_SCREENSHOT, Types.API_DEMAND_SCREENSHOT_SUCCESS, Types.API_DEMAND_SCREENSHOT_FAILURE],
    })
}

/**
 * update content on device
 * @param String uid Device ID
 */
function updateContentViaApi(deviceId) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/${deviceId}/content_push`,
        method: 'POST',
        types: [Types.API_UPDATE_CONTENT, Types.API_UPDATE_CONTENT_SUCCESS, Types.API_UPDATE_CONTENT_FAILURE],
    })
}

/**
 * Reboot device
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function rebootDeviceViaApi(deviceId) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/${deviceId}/reboot`,
        method: 'POST',
        types: [Types.API_REBOOT, Types.API_REBOOT_SUCCESS, Types.API_REBOOT_FAILURE],
    })
}

/**
 * Reboot device
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function restartDeviceViaApi(deviceId) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/${deviceId}/restart`,
        method: 'POST',
        types: [Types.API_RESTART, Types.API_RESTART_SUCCESS, Types.API_RESTART_FAILURE],
    })
}

function clearDeviceCacheViaApi(deviceId) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/${deviceId}/clear_device_cache`,
        method: 'POST',
        types: [Types.API_CLEAR_DEVICE_CACHE, Types.API_CLEAR_DEVICE_CACHE_SUCCESS, Types.API_CLEAR_DEVICE_CACHE_FAILURE],
    })
}

function clearDeviceContentViaApi(deviceId) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/${deviceId}/clear_device_content`,
        method: 'POST',
        types: [Types.API_CLEAR_DEVICE_CONTENT, Types.API_CLEAR_DEVICE_CONTENT_SUCCESS, Types.API_CLEAR_DEVICE_CONTENT_FAILURE],
    })
}

/**
 * Asks a device to update its settings
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function updateSettingsViaApi(deviceId) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/${deviceId}/setting_push`,
        method: 'POST',
        types: [Types.API_UPDATE_SETTINGS, Types.API_UPDATE_SETTINGS_SUCCESS, Types.API_UPDATE_SETTINGS_FAILURE],
    })
}

/**
 * Asks a device to update its settings
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function reloadPromosViaAPI(deviceId) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/${deviceId}/promo_reload`,
        method: 'POST',
        types: [Types.API_RELOAD_PROMOS, Types.API_RELOAD_PROMOS_SUCCESS, Types.API_RELOAD_PROMOS_FAILURE],
    })
}

/**
 * Open status panel
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function openStatusPanelViaAPI(deviceId) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/${deviceId}/open_status_panel`,
        method: 'POST',
        types: [Types.API_OPEN_STATUS_PANEL, Types.API_OPEN_STATUS_PANEL_SUCCESS, Types.API_OPEN_STATUS_PANEL_FAILURE],
    })
}

function clearDevicesList() {
    return {
        type: Types.CLEAR_DEVICES_LIST,
    }
}

export {
    Types,
    clearDevicesList,
    createDevice,
    createOrRestoreDevice,
    deleteDevice,
    demandScreenshotViaApi,
    deviceUpdate,
    fetchAuthKeys,
    fetchAvailableApks,
    fetchDeviceGroups,
    fetchDeviceStatus,
    fetchDeviceTypes,
    fetchDevices,
    fetchScreenshot,
    fetchSingleDevice,
    fetchStoreLocations,
    openStatusPanelViaAPI,
    clearDeviceCacheViaApi,
    clearDeviceContentViaApi,
    rebootDeviceViaApi,
    reloadPromosViaAPI,
    restartDeviceViaApi,
    restoreDevice,
    updateContentViaApi,
    updateLayerExtra,
    updateSettingsViaApi,
}
